var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('nav-component',{staticStyle:{"margin-bottom":"60px"},attrs:{"career":_vm.career.careerPage}}),_c('career-page',{attrs:{"career":_vm.career.careerPage,"content":_vm.career.vagas}}),_c('loader'),_c('footer-component')],1)}
var staticRenderFns = []

export { render, staticRenderFns }